<div provide-parent-form class="wrapper">
	<bb-date-presets [preset]="dateRange ? undefined : 'last-30-days'" [icon]="'line-chart'" (onChanged)="datesChanged($event)"></bb-date-presets>
	<h2>
		{{'KPI_CALCULATIONS' | translate}}
	</h2>
	<div class="kpi-calculations">
		<div *ngIf="project?.kpiCalculations">
			<div class="kpi-row" *ngFor="let kpi of project?.kpiCalculations;let i = index; trackBy: kpiTrackBy">
				<div class="remove-kpi" (click)="removeKPI(i)">
					<i class="fa fa-times"></i>
				</div>
				<bb-form-element [form]="form" [label]="'KPI_LABEL' | translate">
					<input type="text" [(ngModel)]="kpi.label" [name]="'kpi_'+kpi?.id" class="kpi-label" [placeholder]="'KPI_LABEL' | translate" />
				</bb-form-element>
				<bb-form-element [form]="form" [label]="'KPI_DESCRIPTION' | translate" [title]="'KPI_DESCRIPTION_TITLE' | translate">
					<input type="text" [(ngModel)]="kpi.description" [name]="'kpiDescription_'+kpi?.id" class="kpi-description" [placeholder]="'KPI_DESCRIPTION' | translate" />
				</bb-form-element>
				<bb-form-element *ngIf="!kpi.isPercentage" [form]="form" [label]="'GOAL' | translate">
					<input type="number" [(ngModel)]="kpi.goal" [name]="'kpiGoal_'+kpi?.id" class="kpi-goal" [placeholder]="'GOAL' | translate" />
				</bb-form-element>
				<bb-form-element *ngIf="kpi.isPercentage" [form]="form" [label]="'GOAL%' | translate">
					<input type="number" [(ngModel)]="kpi.goal" [name]="'kpiGoal_'+kpi?.id" class="kpi-goal" [placeholder]="'GOAL%' | translate" />
				</bb-form-element>

				<bb-form-element [form]="form" [label]="'GOAL_TYPE' | translate" class="kpi-type-buttons">
					<bb-button [active]="kpi.isPercentage" (click)="onKpiTypeClick('percentage', kpi)">{{ 'PERCENTAGE' | translate }}</bb-button>
					<bb-button [active]="!kpi.isMonthly && !kpi.isPercentage && !kpi.isTime" (click)="onKpiTypeClick('total', kpi)">{{ 'TOTAL' | translate }}</bb-button>
					<bb-button [active]="kpi.isMonthly" (click)="onKpiTypeClick('monthly', kpi)">{{ 'MONTHLY' | translate }}</bb-button>
					<bb-button [active]="kpi.isTime" (click)="onKpiTypeClick('time', kpi)">{{ 'TIME' | translate }}</bb-button>
				</bb-form-element>

				<bb-form-element [form]="form" [label]="'IS_IMPORTANT' | translate">
					<bb-check [(ngModel)]="kpi.isImportant" [name]="'important_'+kpi?.id"></bb-check>
				</bb-form-element>

				<bb-form-element [form]="form" [label]="'DATAFEED' | translate" [helpMessage]="'HELP.PROJECT_KPI_DATAFEED' | translate">
					<bb-entity-selector 
						[(ngModel)]="kpi.externalDataId" 
						name="kpi-datafeed-{{i}}" 
						[entityType]="'datafeed'"
						(ngModelChange)="onFeedSelected($event, kpi)"
						[filterSet]="[{
							filters: [{
								type: 'datafeed',
								field: 'feedType',
								operator: 'is',
								value: 'default'
							}]
						}]"
					></bb-entity-selector>
					<p *ngIf="kpi.externalDataId && dateColumnOptions[kpi.id]?.length < 1" class="message warning">
						<i class="fa fa-warning"></i><span>{{ 'HELP.DATAFEED_NO_COLUMNS' | translate }}<a [routerLink]="['/library/datafeed/', kpi.externalDataId, 'metadata']">{{ 'DATAFEED' | translate }}.</a></span>
					</p>
				</bb-form-element>
					

				<bb-form-element *ngIf="dateColumnOptions[kpi.id]?.length > 0" [form]="form" [label]="'DATAFEED_DATE_COLUMN' | translate">
					<bb-entity-selector 
						*ngIf="dateColumnOptions[kpi.id]?.length > 0"
						[(ngModel)]="kpi.dateColumn" 
						name="kpi-dateColumn-{{i}}" 
						[options]="dateColumnOptions[kpi.id]"
						(ngModelChange)="onDateColumnSelected($event, kpi)"
					></bb-entity-selector>
				</bb-form-element>

				<bb-form-element *ngIf="configuration" [form]="form" [label]="'CALCULATION' | translate">
					<project-kpi-maker 
						[(ngModel)]="kpi.parts" 
						[name]="'kpiParts_'+kpi?.id" 
						[project]="project" 
						[kpi]="kpi"
						[kpiId]="kpiId" 
						[goal]="kpi.goal" 
						[isMonthly]="kpi.isMonthly" 
						[isPercentage]="kpi.isPercentage" 
						[datafeedVars]="datafeedVars[kpi.id]"
						[configuration]="configuration">
					</project-kpi-maker>
				</bb-form-element>
				<div class="actions">
					<span class="button" (click)="duplicateKPI(i)"><i class="fa fa-copy"></i>{{'DUPLICATE' | translate}}</span>
					
					<span class="button" [class.disabled]="i === 0" (click)="moveToIndex(i, i - 1)"><i class="fa fa-arrow-up"></i></span>
					<span class="button" [class.disabled]="i === project?.kpiCalculations?.length - 1" (click)="moveToIndex(i, i + 1)"><i class="fa fa-arrow-down"></i></span>
				</div>
			</div>
		</div>
		<span class="button" (click)="addKPI()" ><i class="fa fa-plus"></i>{{'ADD_KPI' | translate}}</span>
	</div>
</div>
